/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'well': {
    width: 16,
    height: 16,
    viewBox: '0 0 21.76 21.76',
    data: '<defs/><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><circle pid="0" class="cls-1" cx="10.88" cy="10.88" r="10.88"/><circle pid="1" class="cls-2" cx="6.72" cy="8.36" r="1.64"/><circle pid="2" class="cls-2" cx="15.45" cy="8.36" r="1.64"/><path pid="3" class="cls-3" d="M17.09 14.36s-1.5 3-6 3-6-3-6-3"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/well.js